import type { Theme } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

import { themeOptions } from "../options";

import { components } from "./components";

export const theme: Theme = createTheme({ ...themeOptions, components });
